var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"text-left",class:this.inset ? 'mx-5' : '',attrs:{"color":_vm.getColor,"dense":"","icon":_vm.getIcon,"text":"","type":"info"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }